import { Result, Success } from "./index";

/**
 * @memberof Result
 */
const isSuccess = <E, A>(result: Result<E, A>): result is Success<A> =>
  result._tag === "Success";

export default isSuccess;
